import React, {useState} from 'react';
import Home from "../components/Homepage";
import "./custompages.css";
import {useKeycloak} from "@react-keycloak/web";
import {wait} from "@testing-library/user-event/dist/utils";

const ShowResponse = (props) => {

    let explanation = "";
    let imageUrl = "tick.png";
    switch (props.text.VerificationReport.ReasonCode) {
        case "MBAM":
            explanation = "Might Be A Match - The name submitted is a close match\n" +
                "with the name on the account. Please check the actual\n" +
                "name that has been returned";
            imageUrl = "question.png";
            break;
        case "BANM":
            explanation = "Business Account, Name Matches - The name submitted\n" +
                "matches the name on the account, however this is a\n" +
                "Business account, not a Personal account";
            imageUrl = "question.png";
            break;
        case "PANM":
            explanation = "Personal Account, Name Matches - The name submitted\n" +
                "matches the name on the account, however this is a\n" +
                "Personal account, not a Business account";
            imageUrl = "question.png";
            break;
        case "BAMM":
            explanation = "Business Account, Might Match - The name submitted is a\n" +
                "close match with the name on the account. Please check\n" +
                "the actual name that has been returned. In addition, this is\n" +
                "a Business account, not a Personal account";
            imageUrl = "question.png";
            break;
        case "PAMM":
            explanation = "Personal Account, Might Match - The name submitted is\n" +
                "a close match with the name on the account. Please check\n" +
                "the actual name that has been returned. In addition, this\n" +
                "is a Personal account, not a Business account";
            imageUrl = "question.png";
            break;
        case "ANNM":
            explanation = "Account Name Not Match - The name submitted does\n" +
                "not match the name on the account";
            imageUrl = "error.png";
            break;
        case "AC01":
            explanation = "The account number submitted does not exist";
            imageUrl = "cross.png";
            break;
        case "IVCR":
            explanation = "InValid Customer Reference - This account requires\n" +
                "secondary reference data to be provided. This data is\n" +
                "either missing or invalid";
            imageUrl = "cross.png";
            break;
        case "CASS":
            explanation = "Current Account Switching Service - This account has been\n" +
                "switched using the Current Account Switching Service, and\n" +
                "should no longer be used. Please get the new account\n" +
                "details.";
            imageUrl = "cross.png";
            break;
        case "SCNS":
            explanation = "Sort Code Not Supported - The account submitted does\n" +
                "not belong to the entity that received the request. Please\n" +
                "contact support";
            imageUrl = "cross.png";
            break;
        case "SCNF":
            explanation = "Sort Code Not Found - The sort code submitted is not\n" +
                "valid";
            imageUrl = "cross.png";
            break;
        case "ACNS":
            explanation = "ACcount Not Supported - The submitted account is not\n" +
                "supported by the CoP network. CoP check could not be\n" +
                "performed";
            imageUrl = "information.png";
            break;
        case "OPTO":
            explanation = "OPT Out - The Payee has opted out of the CoP service.\n" +
                "CoP check could not be performed";
            imageUrl = "information.png";
            break;
        case "BNRT":
            explanation = "Bank Not Reachable Temporarily - The receiving\n" +
                "institution is not currently available, please try again later.\n" +
                "CoP check could not be performed";
            imageUrl = "information.png";
            break;
        case "BNRP":
            explanation = "Bank Not Reachable Permanently - The receiving\n" +
                "institution is no longer available to receive CoP requests.\n" +
                "CoP check could not be performed";
            imageUrl = "information.png";
            break;
        case "RLR":
            explanation = "Request Limit Reached – User has made too many invalid\n" +
                "CoP requests in a short time period. Please wait for 5\n" +
                "minutes before attempting any new CoP checks";
            imageUrl = "halt.png";
            break; //TODO: cross za default
    }

    let name, ReasonCode, RequestReference, RespondingBankName, FailedRequests, RespondingBankCode, RespondingBankTimeMs;
    if(props.text.VerificationReport.Name === undefined) {
        name = "-";
    }
    else {
        name = props.text.VerificationReport.Name;
    }

    if(props.text.VerificationReport.ReasonCode === undefined) {
        ReasonCode = "-";
    }
    else {
        ReasonCode = props.text.VerificationReport.ReasonCode;
    }

    if(props.text.Meta.RespondingBankCode === undefined) {
        RespondingBankCode = "-";
    }
    else {
        RespondingBankCode = props.text.Meta.RespondingBankCode;
    }

    if(props.text.Meta.RequestReference === undefined) {
        RequestReference = "-";
    }
    else {
        RequestReference = props.text.Meta.RequestReference;
    }

    if(props.text.Meta.RespondingBankName === undefined) {
        RespondingBankName = "-";
    }
    else {
        RespondingBankName = props.text.Meta.RespondingBankName;
    }

    if(props.text.Meta.FailedRequests === undefined) {
        FailedRequests = "-";
    }
    else {
        FailedRequests = props.text.Meta.FailedRequests;
    }

    if(props.text.Meta.RespondingBankTimeMs === undefined) {
        RespondingBankTimeMs = "-";
    }
    else {
        RespondingBankTimeMs = props.text.Meta.RespondingBankTimeMs;
    }


    return (
        <div className="response-wrap">
            <div className="response-container">
                <div className="header"><h5><b>Response</b></h5>
                    <p className="timestamp">{props.text.Timestamp}</p>
                </div>
                <div className="response-body">
                    <div className="response-image">
                        <img className="response-image-element" src={imageUrl} alt="image response"/>
                    </div>
                    <div className="response-leftSide">
                        <div className="response-variable">
                            <p>Matched</p>
                            <p>Bank Account Name</p>
                            <p>Reason Code</p>
                            <p>Responding Bank Code</p>
                        </div>
                        <div className="response-data">
                            <p>{props.text.VerificationReport.Matched ? "true" : "false"}</p>
                            <p>{name}</p>
                            <p title={explanation}>{ReasonCode}</p>
                            <p>{RespondingBankCode}</p>
                        </div>
                    </div>
                    <div className="response-rightSide">
                        <div className="response-variable">
                            <p>Request Reference</p>
                            <p>Responding Bank Name</p>
                            <p>Failed requests</p>
                            <p>Responding Bank Time Ms</p>
                        </div>
                        <div className="response-data">
                            <p>{RequestReference}</p>
                            <p>{RespondingBankName}</p>
                            <p>{FailedRequests}</p>
                            <p>{RespondingBankTimeMs}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const ManualCopCheck = () => {

    const { keycloak, initialized } = useKeycloak();
    let url = window.location.href
    let arr = url.split("/");
    //console.log(arr);
    url = arr[0] + "//" + arr[2] + "/manualcopcheck";
    //url = window.location.pathname + "/manualcopcheck";
    // console.log("------------------MANUAL COP URL--------------------");
    // console.log(url);

    function appendCharacter(length) {
        var result = '';
        var character = '-';
        var charactersLength = character.length;
        for (var i = 0; i < length; i++) {
            result += character.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    //combine first and last name and convert it to uppercase, it cant be longer than 20 characters, if less fill
    let fullName = keycloak.tokenParsed.name.replace(/ /g, '');
    if(fullName.length>20) {
        fullName = fullName.substring(0,20).toUpperCase();
    } else {
        let randomChar = appendCharacter(20 - fullName.length)
        fullName = fullName.toUpperCase() + randomChar;
        console.log("CustomerReference: " + fullName);
    }

    let customerReference = fullName;



    let [sortCode, setSortCode] = useState("");
    let [accountNumber, setAccountNumber] = useState("");
    const [secondaryRef, setSecondaryRef] = useState("");
    const [accountType, setAccountType] = useState("Personal");
    let [name, setName] = useState("");


    let responseStorage = [];
    const response = [];

    let org_id = null;
    if (keycloak.resourceAccess && keycloak.resourceAccess.portal_client && keycloak.resourceAccess.portal_client.roles) {
        org_id = keycloak.resourceAccess.portal_client.roles;
    }
    // console.log("--------------");
    // console.log(org_id);
    if (Array.isArray(org_id) && org_id.length > 1) {
        console.log("More than one OrgID!")
        org_id = null;
    } else {
        console.log("One OrgID!")
    }

    let displayMessage;


    async function sendGatewayRequest(sortCode, identification, typeAccount, accountName, secondaryIdentification, customerReference) {
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization':'Bearer ' + keycloak.token,
                'Content-Type': 'text/plain;charset=UTF-8'
            },
            body:JSON.stringify( {
                'SchemeName': 'SortCodeAccountNumber',
                'AccountType': typeAccount,
                'Identification': sortCode + identification,
                'Name': accountName,
                'SecondaryIdentification': secondaryIdentification,
                'CustomerReference': customerReference // 20 first_last(uppercase) + rest
            })
        })
            .then(res => res.text())
            .then(text => {
                if(!text.includes("Error")) {
                    //localStorage.setItem("numberOfRequests", numberOfRequests++ + "");
                    response.push(text);
                    localStorage.setItem("response", response);
                    console.log("=======API CALL=======");
                    console.log(localStorage.getItem("response"));
                    console.log("PORTAL RESPONSE DATA");
                    responseStorage.push(localStorage.getItem("response"));
                    console.log(responseStorage);
                    addComponent();
                }
                else {
                    console.log(text);
                    let responseObject = JSON.parse(text);
                    let message = responseObject.Error;
                    if(message !== undefined) {
                        displayMessage = message + "\n";
                    } else {
                        displayMessage = "Server error\n";
                    }
                    document.getElementById("displayMessage").style.color = "red";
                    document.getElementById("displayMessage").innerHTML = displayMessage;
                }
            })
            .catch(err => console.error(err))
    }

    const handleSubmit = (event) => {

        const myButton = document.getElementById('checkButton');
        if(org_id == null) {
            myButton.disabled = true;
            displayMessage = "ERROR ORGID MISSING OR MORE THAN 1.\n";
            document.getElementById("displayMessage").style.color = "red";
            document.getElementById("displayMessage").innerHTML = displayMessage;
            return;
        }

        event.preventDefault();
        sortCode = document.getElementById("sortCode").value;
        accountNumber = document.getElementById("accountNumber").value;

        displayMessage = "";
        document.getElementById("displayMessage").innerHTML = displayMessage;
        document.getElementById("displayMessage").style.fontWeight = "bold";


        document.getElementById("sortCode").style.borderColor = "black";
        document.getElementById("accountNumber").style.borderColor = "black";
        document.getElementById("name").style.borderColor = "black";
        document.getElementById("secondaryRef").style.borderColor = "black";

        sortCode = sortCode.replaceAll("-", "");
        //console.log(sortCode);

        //console.log(document.getElementById("sortCode").value);

        if(sortCode.length >= 14 && sortCode.match(/^[0-9]{6,}$/)) {
            accountNumber = sortCode.substring(6,14);
            sortCode = sortCode.substring(0,6);
            document.getElementById("sortCode").innerHTML = "";
            document.getElementById("sortCode").value = sortCode;
            document.getElementById("accountNumber").value = accountNumber;
            //console.log(sortCode)
            //console.log(accountNumber)
        }

        accountNumber = accountNumber.replaceAll("-", "");
        //name = name.replaceAll(/[^a-zA-Z]/g, "");

        console.log("Checking for condition to send request!");
        if (sortCode.length >= 6 && sortCode.match(/^[0-9]{6,}$/) && accountNumber.length >= 8 && accountNumber.match(/^[0-9]{8,}$/) && name.length > 2 && name.length < 139 && secondaryRef.length < 141) {
            accountNumber = accountNumber.substring(0,8);
            sortCode = sortCode.substring(0,6);
            document.getElementById("sortCode").innerHTML = "";
            document.getElementById("sortCode").value = sortCode;
            document.getElementById("accountNumber").innerHTML = "";
            document.getElementById("accountNumber").value = accountNumber;
            // document.getElementById("name").innerHTML = "";
            // document.getElementById("name").value = name.trim();
            console.log("Sending request to gateway");
            sendGatewayRequest(sortCode, accountNumber, accountType, name, secondaryRef, customerReference).catch(e => displayMessage = displayMessage + "Problem with getting data!\n");
        } else {
            if (sortCode.length !== 6 || !sortCode.match(/^[0-9]{6,}$/)) {
                document.getElementById("sortCode").style.borderColor = "red";
                displayMessage = displayMessage + "Please enter 6 numbers for SortCode!\n";
            }
            if (accountNumber.length !== 8 || !accountNumber.match(/^[0-9]{8,}$/)) {
                document.getElementById("accountNumber").style.borderColor = "red";
                displayMessage = displayMessage + "Please enter 8 numbers for AccountNumber!\n";
            }
            if (name.length < 3) {
                document.getElementById("name").style.borderColor = "red";
                displayMessage = displayMessage + "Name must have at least 3 characters!\n";
            }
            if (name.length > 138) {
                document.getElementById("name").style.borderColor = "red";
                displayMessage = displayMessage + "Name must have maximum 138 characters!\n";
            }
            if (secondaryRef.length > 140) {
                document.getElementById("secondaryRef").style.borderColor = "red";
                displayMessage = displayMessage + "Secondary ref must have maximum 140 characters!\n";
            }

            document.getElementById("displayMessage").style.color = "red";
            document.getElementById("displayMessage").innerHTML = displayMessage;
        }
        console.log(displayMessage);
    }


    const clearFields = (event) => {
        event.preventDefault();
        document.getElementById("sortCode").value = "";
        document.getElementById("sortCode").style.borderColor = "black";
        setSortCode("");
        document.getElementById("accountNumber").value = "";
        document.getElementById("accountNumber").style.borderColor = "black";
        setAccountNumber("");
        document.getElementById("name").value = "";
        document.getElementById("name").style.borderColor = "black";
        setName("");
        document.getElementById("accountType").value = "Personal";
        setAccountType("Personal");
        document.getElementById("secondaryRef").value = "";
        document.getElementById("secondaryRef").style.borderColor = "black";
        setSecondaryRef("");
        document.getElementById("displayMessage").innerHTML = "";
    }


        const [components, setComponents] = useState([]);

        function addComponent() {
            wait(600).then(r => {
                // console.log("COMPONENT DATA");
                // console.log(responseStorage);
                setComponents([...components, JSON.parse(responseStorage[responseStorage.length-1])]);
            });
        }

    const clearHistory = (event) => {
        event.preventDefault();

        console.log("Clearing request history.");
        setComponents([]);

    }


    return (
        <>
            <Home/>
            <div className="main-container">
                <div><h5 className="header">Manual CoP Check</h5></div>
                <div className="request-manual-cop">

                    <div className="form-group">
                        <div className="">
                            <h5 className="form-name"><b>Request</b></h5>
                        </div>

                        <div id="sortCodeElement" className="form-element">
                            <label htmlFor="sortCode" className="label-name">Sort code*</label>
                            <input id="sortCode" type="text" className="form-input" name="sortCode"/>
                        </div>

                        <div id="accountNumberElement" className="form-element">
                            <label htmlFor="accountNumber" className="label-name">Account Number*</label>
                            <input id="accountNumber" type="text" className="form-input" name="accountNumber"/>
                        </div>

                        <div id="nameElement" className="form-element">
                            <label htmlFor="secondaryRef" className="label-name">Name*</label>
                            <input id="name" type="text" className="form-input" name="name"
                                   onChange={(e) => setName(e.target.value)}/>
                        </div>

                        <div id="accountTypeElement" className="form-element">
                            <label htmlFor="accountType" className="label-name">Account Type*</label>
                            <select id="accountType" className="form-input" name="accountType" value={accountType}
                                    onChange={(e) => setAccountType(e.target.value)}>
                                <option value="Personal">Personal</option>
                                <option value="Business">Business</option>
                            </select>
                        </div>

                        <div id="secondaryRefElement" className="form-element">
                            <label htmlFor="sortCode" className="label-name">Secondary Reference</label>
                            <input id="secondaryRef" type="text" className="form-input" name="secondaryRef"
                                   value={secondaryRef} onChange={(e) => setSecondaryRef(e.target.value)}/>
                        </div>

                        <div className="input-buttons">
                            <button className="button-position check-btn" onClick={handleSubmit}>CHECK</button>
                            <button className="button-position clear-btn" onClick={clearFields}>CLEAR FORM</button>
                            <button className="button-position clear-btn" onClick={clearHistory}>CLEAR HISTORY</button>
                        </div>

                        <div id="displayMessageElement">
                            <span id="displayMessage"/>
                        </div>
                    </div>
                </div>
                { components.slice(0).reverse().map((item, i) => (  <ShowResponse text={item} /> ))}
            </div>
        </>
    );
};

export default ManualCopCheck;
